/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Feed_Url_InvalidInputs */

const cs_import_feed_url_invalid = /** @type {(inputs: Import_Feed_Url_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadejte platný odkaz začínající https://`)
};

const en_import_feed_url_invalid = /** @type {(inputs: Import_Feed_Url_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid link starting with https://`)
};

/**
* | output |
* | --- |
* | "Enter a valid link starting with https://" |
*
* @param {Import_Feed_Url_InvalidInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_feed_url_invalid = /** @type {((inputs?: Import_Feed_Url_InvalidInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Feed_Url_InvalidInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_feed_url_invalid(inputs)
	return cs_import_feed_url_invalid(inputs)
});